var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yes-no-modal',{attrs:{"text":"Are you sure you want to leave?","sub-text":"All progress will be lost! Please save as a draft (if available)!"},on:{"back":function($event){return _vm.$emit('back')},"submit":_vm.leave}})
}
var staticRenderFns = []

export { render, staticRenderFns }